import graphql from "babel-plugin-relay/macro";

const GetMonthlyPassDescriptionQuery = graphql`
    query GetMonthlyPassDescriptionQuery($amount: String!) {
        getMonthlyPassDescription(amount:$amount)
    }

`;

export default GetMonthlyPassDescriptionQuery;